import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { getCalendarAgendaViewStore } from '../store/calendarAgendaViewStore';

/**
 * Check if the event matches the selected event
 */
export default function isSelectedCalendarEvent(event: CalendarEvent): boolean {
    return event.ItemId.Id === getCalendarAgendaViewStore().selectedCalendarEventId;
}
